import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import ListTable from "components/ListTable";
import { PrimaryLink } from "components/Links";
import { fontSize, margins } from "style";
import { ICON_SIZE, ICON_TYPE, withIcon } from "components/Icon";
import { Editor } from "components/Form";
import { Paragraph } from "components/Text";
import { useLinks } from "hooks";

/**
 * RoleDetails
 *
 * @param {Object}   role
 * @param {Object}   mission
 * @param {String}   marginSize
 * @param {Boolean}  isLoading
 */
const RoleDetails = ({ role, mission, marginSize, isLoading, ...props }) => {
  const links = useLinks();
  const isOrganizationConfidential = mission?.isOrganizationConfidential;

  return (
    <ListTable
      data={TABLE_DATA(mission, role, isOrganizationConfidential)}
      loading={isLoading}
      title={<FormattedMessage id="Missions.MissionRole.RoleDetails" />}
      secondaryTitle={
        <LinkRole
          css={styles.primary_link}
          href={links.public_mission_role(mission?.uuid, role?.slug)}
          target="_blank"
          withMoreIcon
        >
          <FormattedMessage id="Missions.MissionRole.PublicRoleLink" />
        </LinkRole>
      }
      marginSize={marginSize}
      resultsPerPage={TABLE_DATA().length}
      {...props}
    />
  );
};

const TABLE_DATA = (mission, role, isOrganizationConfidential) => [
  {
    label: <FormattedMessage id="Missions.MissionRole.RoleTitle" />,
    value: role?.name,
  },
  {
    label: <FormattedMessage id="Missions.MissionRole.ExpectedStartDate" />,
    value: moment(role?.startDate).format("MMMM Do, YYYY"),
  },
  {
    label: <FormattedMessage id="Global.Engagement" />,
    value: `${role?.engagementTime} hours/week`,
  },
  {
    label: <FormattedMessage id="Candidate.CandidateRoleDetails.AboutOrg" />,
    description: isOrganizationConfidential ? null : mission?.companyDescriptionJson ? (
      <Editor value={mission?.companyDescriptionJson} css={styles.body} readOnly={true} />
    ) : (
      <Paragraph data={mission?.companyDescription} />
    ),
  },
];

const styles = {
  primary_link: css`
    font-size: ${fontSize.small};
    line-height: 1.3;
  `,
  body: css`
    margin: 0;
    padding: 0;
    border: 0;
    box-shadow: none;
  `,
};

const LinkRole = withIcon(PrimaryLink, {
  type: ICON_TYPE.eye,
  size: ICON_SIZE.medium,
  color: "inherit",
});

RoleDetails.defaultProps = {
  marginSize: margins.normal,
};

RoleDetails.propTypes = {
  role: PropTypes.object,
  mission: PropTypes.object,
  marginSize: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default RoleDetails;
